import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UrlPreviewsQueryVariables = Types.Exact<{
  input: Types.GetUrlPreviewsInput;
}>;


export type UrlPreviewsQuery = { urlPreviews: { previews: Array<any> } };


export const UrlPreviewsDocument = /*#__PURE__*/ gql`
    query urlPreviews($input: GetUrlPreviewsInput!) {
  urlPreviews(input: $input) {
    previews
  }
}
    `;

export function useUrlPreviewsQuery(options: Omit<Urql.UseQueryArgs<UrlPreviewsQueryVariables>, 'query'>) {
  return Urql.useQuery<UrlPreviewsQuery, UrlPreviewsQueryVariables>({ query: UrlPreviewsDocument, ...options });
};